import React, { useState } from 'react';
const img_api = process.env.REACT_APP_IMG_API;

const defaultLoadingIcon = (fontSize) => (
  <i className="fa fa-spinner fa-spin d-flex justify-content-center align-items-center h-100 w-100" style={{ fontSize, color: '#5c5c5c' }}></i>
);

const ImageWithBaseApi = (props) => {
  const [loading, setLoading] = useState(true);
  const fullSrc = `${img_api}${props.src}`;
  const loadingIcon = defaultLoadingIcon(props.loadingIconFontSize || '60px');

  const handleLoad = () => {
    setLoading(false);
  };

  return (
    <>
      {loading && (
        <div className={props.ladingClass} style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {loadingIcon}
        </div>
      )}
      <img
        className={props.className}
        src={fullSrc}
        height={props.height}
        alt={props.alt}
        width={props.width}
        id={props.id}
        style={{ ...props.style, display: loading ? 'none' : undefined }}
        onLoad={handleLoad}
      />
    </>
  );
};

export default ImageWithBaseApi;